import type { ShowSummary } from '@fetmode/types';

/** Party lobby — public floor stream before enough participants join. */
export function isPartyLobby(show: Pick<ShowSummary, 'type' | 'status'>): boolean {
  return show.type === 'PARTY' && show.status === 'WAITING';
}

/** Ticket lobby — public floor until the scheduled show starts. */
export function isTicketLobby(show: Pick<ShowSummary, 'type' | 'status'>): boolean {
  return show.type === 'TICKET' && show.status === 'WAITING';
}

/** Main stage live, party lobby, or ticket lobby — public watch floor. */
export function isPublicShowFloor(show: Pick<ShowSummary, 'type' | 'status'>): boolean {
  return show.status === 'LIVE' || isPartyLobby(show) || isTicketLobby(show);
}

/** Room chat is visible for any active show; send is gated separately via the input. */
export function isChatActiveShow(show: Pick<ShowSummary, 'type' | 'status'>): boolean {
  return show.status !== 'ENDED';
}
